import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid')
import { Form, Button } from 'react-bootstrap';

const _ = {
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    isEqual:    require('lodash/isEqual'),
    map:        require('lodash/map'),
};

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const OrganizationStore = require('../../stores/OrganizationStore');
const OrganizationActions = require('../../actions/OrganizationActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
import AIModelParamsEditor from './AIModelParamsEditor';

const propTypes = {
    user: PropTypes.object.isRequired
};

const defaultProps = {

};

class AdminAccountFeaturesEditor extends React.Component {
    constructor(props) {
        super(props);

        const orgStoreState = OrganizationStore.getStateOrganization(props.user.id);
        let customConfig = null;
        let customConfigDirty = false;
        if (orgStoreState.orgUserSettings) {
            ({ customConfig, customConfigDirty } = this.ensureValidCustomConfig(orgStoreState.orgUserSettings.custom_config));
        }
        this.state = {
            accountFeatures: orgStoreState.orgAccountFeatures || {},
            customConfig,
            getActionId: null,
            updateActionId: null,
            dirty: false,
            error: null
        };

        this.unsubscribes = [
            OrganizationStore.listen(this.onOrgStoreChange)
        ];
    }

    componentDidMount() {
        this.getOrgFeatures(this.props.user.id);
        this.getOrgSettings(this.props.user.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.id === this.props.user.id) {
            return;
        }
        this.getOrgFeatures(this.props.user.id);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    ensureValidCustomConfig=(customConfig)=>{
        let customConfigDirty = false;
        if (!customConfig) {
            customConfig = {};
            customConfigDirty = true;
        }
        if (!customConfig.modelParamCases) {
            customConfig.modelParamCases = [];
            customConfigDirty = true;
        }
        else {
            customConfig.modelParamCases = customConfig.modelParamCases.slice();
        }
        
        _.forEach(Globals.ai.useCases,(useCase)=>{
            if (!_.find(customConfig.modelParamCases,{useCase})) {
                customConfigDirty = true;
                let modelParams = Globals.ai.useCaseModelParams[useCase];
                customConfig.modelParamCases.push({...modelParams, useCase});
            }
        });
        return { customConfig, customConfigDirty };
    }
    
    setModelParams=(usageEntry)=>{
        let customConfig = {...this.state.customConfig };
        let i = _.findIndex(customConfig.modelParamCases,{useCase: usageEntry.useCase});
        if (i < 0) {
            console.log("did not find useCase:",usageEntry.useCase);
            return;
        }
        let customConfigDirty = false;
        if (!_.isEqual(usageEntry, customConfig.modelParamCases[i])) {
            customConfig.modelParamCases[i] = usageEntry;
            this.setState({customConfig, customConfigDirty: true});
        }
    }

    getOrgFeatures=(userId)=>{
        let getActionId = uuid.v4();
        this.setState({getActionId},()=>{
            OrganizationActions.getOrgAccountFeatures(getActionId, userId);
        });
    }
    
    getOrgSettings=(userId)=>{
        let getSettingsActionId = uuid.v4();
        this.setState({getSettingsActionId},()=>{
            OrganizationActions.getOrgUserSettings(getSettingsActionId, { orgId: userId });
        });
    }
    
    onRefresh=()=>{
        this.getOrgFeatures(this.props.user.id);
        this.getOrgSettings(this.props.user.id);
    }

    onOrgStoreChange=(state)=>{
        const orgId = this.props.user.id;
        if (state.action.id === this.state.getActionId) {
            if (state.action.error) {
                this.setState({
                    getActionId: null, 
                    error: state.action.error
                });
            }
            else {
                const orgStoreState = OrganizationStore.getStateOrganization(orgId);
                this.setState({
                    getActionId: null, 
                    dirty: false,
                    error: null,
                    accountFeatures: orgStoreState.orgAccountFeatures || {},
                });
            }
        }
        else if (state.action.id === this.state.updateActionId) {
            if (state.action.error) {
                this.setState({
                    updateActionId: null, 
                    error: state.action.error
                });
            }
            else {
                const orgStoreState = OrganizationStore.getStateOrganization(orgId);
                this.setState({
                    updateActionId: null, 
                    dirty: false,
                    error: null,
                    accountFeatures: orgStoreState.orgAccountFeatures || {},
                });
            }
        }        
        else if (state.action.id === this.state.getSettingsActionId) {
            if (state.action.error) {
                this.setState({
                    updateActionId: null, 
                    error: state.action.error
                });
            }
            else {
                const orgStoreState = OrganizationStore.getStateOrganization(orgId);
                let {customConfig, customConfigDirty} = this.ensureValidCustomConfig(orgStoreState.orgUserSettings.custom_config);

                this.setState({
                    getSettingsActionId: null, 
                    error: null,
                    customConfig,customConfigDirty,
                });
            }
        }
        else if (state.action.id === this.state.updateCustomConfigActionId) {
            if (state.action.error) {
                this.setState({
                    updateCustomConfigActionId: null, 
                    error: state.action.error
                });
            }
            else {
                const orgStoreState = OrganizationStore.getStateOrganization(orgId);
                console.log("orgStoreState:",orgStoreState); // FIXME: remove debug spam
                let { customConfig, customConfigDirty } = this.ensureValidCustomConfig(orgStoreState.orgUserSettings.custom_config);
                this.setState({
                    updateCustomConfigActionId: null, 
                    error: null,
                    customConfig,
                    customConfigDirty,
                });
            }
        }
    }

    onUpdateFeatures=()=>{
        if (!this.state.dirty) {
            return;
        }

        const updateActionId = uuid.v4();
        this.setState({ updateActionId }, () => {
            OrganizationActions.updateOrgAccountFeatures(updateActionId, this.props.user.id, this.state.accountFeatures);
        });
    }

    onUpdateCustomConfig=()=>{
        if (!this.state.customConfigDirty) {
            return;
        }
        const updateCustomConfigActionId = uuid.v4();
        let orgId = this.props.user.id;
        let customConfig = this.state.customConfig;
        this.setState({ updateCustomConfigActionId }, () => {
            OrganizationActions.updateOrgCustomConfig(updateCustomConfigActionId, {orgId, customConfig});
        });
    }

    
    setFeature=(feature_key,value)=>{
        let accountFeatures = {...this.state.accountFeatures};
        accountFeatures[feature_key] = value;
        this.setState({accountFeatures, dirty:true});
    }

    render() {
        if (this.state.getActionId) {
            return <LoadingMainContent />;
        }

        const accountFeatures = this.state.accountFeatures;
        let featureList = [];
        _.forEach(Globals.users.account_features,(feature_key)=>{
            let k = `org-account-feature-${feature_key}-edit`; 
            if (feature_key === 'useVoiceSynthesisMistral') {
                return; // not used
            }
            featureList.push(
                <div key={k} className="feature-row">
                    <input id={k} type="checkbox" 
                        checked={accountFeatures[feature_key] ? true : false}
                        title={`${Strings['en'].user.account_features[feature_key]} (${feature_key})`} 
                        onChange={(e)=>{this.setFeature(feature_key,e.target.checked)} }/>
                    <label htmlFor={k}>
                        {Strings['en'].user.account_features[feature_key]}
                    </label>
                </div>
            );
        });

        return (
            <div className="org-account-feature-editor">
                <Form>
                    {featureList}
                    <Button onClick={this.onUpdateFeatures} disabled={this.state.updateActionId || !this.state.dirty || this.state.error}>
                        Update
                    </Button>
                    { this.state.customConfig ? 
                    _.map(this.state.customConfig.modelParamCases,(usageEntry,i)=>(
                        <AIModelParamsEditor key={i} modelParameters={usageEntry} onChange={this.setModelParams}/>
                    )) : null }
                    <Button onClick={this.onUpdateCustomConfig} disabled={this.state.updateCustomConfigActionId || !this.state.customConfigDirty || this.state.error}>
                        Update Custom Config
                    </Button>
                </Form>
                { this.state.error ? 
                <div className="col-12">
                    <ErrorBox className="margin-bottom-md" error={this.state.error} />
                    <Button className="btn btn-primary" onClick={this.onRefresh}>
                        Refresh
                    </Button>
                </div>
                : null }
            </div>
        );
    }
}

AdminAccountFeaturesEditor.propTypes = propTypes;
AdminAccountFeaturesEditor.defaultProps = defaultProps;

export default AdminAccountFeaturesEditor;